<template>
  <div id="employee" class="d-flex">
    <MainBarMenuV2 />
    <div class="header-top">
      <div class="container-fluid">
        <HeadingUser />
      </div>
    </div>
    <div class="layout-content container-fluid mt-5">

      <!-- CARGAR DOCUMENTO -->
      <div class="row mt-5">
        <div class="col-10 mx-auto mt-5">
            <h1 class="col-12">Gestión de la Información</h1>
            <div class="d-flex">
           <!-- <div class="col-sm-12 col-md-5 mt-sm-3">
                    <b-alert variant="success" show>Carga de archivo general de ausentismos en planta</b-alert>
                    <div class="file-upload-img col-12">
                        <input
                        type="file"
                        id="fileDocuEmployees"
                        @change="fileSelectedEmployees"
                        accept=".xlsx"
                        required
                        />
                        <span v-if="!nameFile">
                        <img class="col-12" src="@/assets/images/settler/uploadFile.jpg" />
                        </span>
                        <span v-else class="col-12" style="display: table; margin: 0 auto">
                        <p class="p3">
                            <b>{{ nameFile }}</b>
                        </p>
                        </span>
                    </div>
          </div> -->

            <!-- Filtro -->
            <div class="col-7 ">
            <div class="table-views">
                <div class="col-12 p-3 t-head">
                    <p class="m-0">Agrega un ausentismo de manera manual</p>
                </div>
                <div class="p-3">
                <p class="mt-2 choose">Busca algun trabajador por su nombre, cedula o Sharp ID</p>
                <v-select class="mt-3 col-6 p-0 " label="name" :options="employeesBySearch" v-model="employee" @search="filterEmployees" @input="loadData()">
                    <template slot="no-options">
                    No se encontro ningun trabajador
                    </template>
                </v-select>
                </div>
                <div v-if="viewProfile" class="col-12 p-3 d-flex mx-auto align-items-center justify-content-around">
                            <div class="col-3">
                                <div class="d-flex flex-column">
                                    <img class="centerImg1 mt-3 mx-auto"  :src="serverPath + '/' + employeeInfo.data.employee.image" width="100%">
                                </div>
                            </div>
                            <div class="col-9 px-3 table-responsive table-employee">
                                <datatable
                                :columns="datatableEmployee1.columns"
                                :data="datatableEmployee1.rows"
                                class="col-12 mt-5"
                                >
                                </datatable>
                            </div>
                </div>
                <router-link v-if="viewProfile" :to="'/detailAbsenteeism/' + employeeInfo.data.employee.id"  class="col-6">
                        <button  class="btn-create new-responsive">Agregar nuevo ausentismo <span>+</span></button>
                </router-link>
            </div>
                <router-link to="/resumeAbs"  class="col-6 mt-3 buttonColapse2 d-flex align-items-center">
                    <div class="textButtonColapse m-3 d-flex align-items-center justify-content-between">
                        <p class="m-0 pr-2 font-weight-bold">Consultar resumen de ausentismos</p>
                        <img class="centerImg1 arrow" src="@/assets/images/icons/eye.svg" width="20px">
                    </div>
                </router-link>
            </div>
            </div>
        </div>
        </div>
    </div>
</div>
</template>

<script>
import { mapState,mapActions } from "vuex";
import MainBarMenuV2 from "../../components/layouts/MainBarMenuV2.vue";
import HeadingUser from "../../components/user/HeadingUser.vue";
import serverConfig from "./../../services/config";
export default {
    name: "employee",
    components: {
    MainBarMenuV2,
    HeadingUser
  },
    data() {
        return {
            serverPath: serverConfig.permisosURL,
            employee:{},
            runtime:'',
            nameFile: "",
            datatableEmployee1: {
              columns:[],
              rows:[]
            },
            viewProfile:false
        }
    },
    computed: {
    ...mapState("modOhAnalyst", [
        "loading",
        "loading2",
        "error",
        "message",
        "employeeInfo",
        "employeesBySearch",
        "previousUser"
      ]),
  },
  beforeMount() {
        this.actGetEmployeesBySearch()
        if(this.previousUser !== ''){
            this.employee.id = this.previousUser
            this.actGetEmployeeInfo(this.previousUser)
        }
  },
    methods: {
        ...mapActions("modOhAnalyst", [
        'actGetEmployeeInfo',
        'actGetEmployeesBySearch',  
        ]),

        filterEmployees(search,loading){
            console.log('aqui')
            loading(true)
            this.actGetEmployeesBySearch(search).then(() => loading(false))
        },
        fileSelectedEmployees() {
        this.$root.$emit('bv::show::modal','modal-upload')
        const dato = document.querySelector("#fileDocuEmployees");
        this.nameFile = dato.files[0].name;
        },

        loadData(){
        this.actGetEmployeeInfo(this.employee.id).then(() => {
            this.datatableEmployee1.columns = [
                    {
                        label: "Nombre",
                        field: "name",
                        align: "left",
                        headerClass: "theading",
                    },
                    {
                        label: "Área",
                        field: "area",
                        align: "left",
                        headerClass: "theading",
                    },
                    {
                        label: "Fecha de ingreso",
                        field: "startDate",
                        align: "left",
                        headerClass: "theading",
                    },
                    
           ]
            this.datatableEmployee1.rows = []

           this.datatableEmployee1.rows.push({
               name:this.employeeInfo.data.employee.employee,
               area:this.employeeInfo.data.employee.area,
               startDate:this.employeeInfo.data.employee.created_at,
           })
           this.viewProfile = true
        })

        },

    saveFileSelected() {
      var formData = new FormData();
        const fileSelected = document.querySelector("#fileDocuEmployees");
      formData.append("file", fileSelected.files[0]);
      this.actSaveFileEmployeeHT(formData).then(() => {
            if(this.error.message){
                this.$root.$emit('bv::hide::modal','modal-upload')
                this.$root.$emit('bv::show::modal','modal-fail')
                this.nameFile = ''
            }else{
                this.$root.$emit('bv::hide::modal','modal-upload')
                this.$root.$emit('bv::show::modal','modal-success')
                this.nameFile = ''
            }
      })
    },
    },
}
</script>

<style lang="scss">
#employee {
    .buttonColapse2{
        background: transparent;
        border: 2px solid #269887;
        color:#269887;
        font-size: 14px;
        border-radius: 100px;
    }
    // Input carga de documento
    .drop-container{
        padding: 30px 15px;
        border: #E9ECEE solid 1px;
        border-radius: 15px;
        h3{
        color: #1C3A4E;
        font-size: 20px;
        font-weight: 600;
        }
    }
    .file-upload-img {
        height: 300px;
        border-radius: 15px;
        text-align: center;
        display: flex;
        align-items: center;
        border: 2px #0C9E42 dashed;
        margin-bottom: 15px;
        box-shadow: 0px 6px 24px rgba(110, 116, 134, 0.2);
        
            input[type="file"] {
            opacity: 0;
            filter: alpha(opacity=0);
            display: block;
            position: absolute;
            cursor: pointer;
            z-index: 1;
            height: 200px;
            }

            span p{
                height: 150px;
                display: flex;
                align-items: center;
                justify-content: center;
            }
    }
    .btn-create{
        padding: 12px;
        border-radius: 20px;
        background-color: #269887;
        border: none;
        color: white;
        display: flex;
        align-items: center;
        transition: 0.5s;

        span {
            font-size: 30px;
            line-height: 0;
            margin: 0 5px;
            font-weight: 500;
        }
    }
    .btn-create:hover{
        background-color: #27a391;
        box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.4);
    }
    // Tabla busqueda del personal
    .table-views{
        box-shadow: 0px 6px 24px rgba(110, 116, 134, 0.2);
        border-radius: 8px;
        border:#DDDDDD solid 1px;
        padding: 0;
        font-size: 14px;
        height: max-content;
        .t-head{
            background-color: #F5F5F5;
            p{
                font-size: 16px;
                font-weight: 600;
                color: #1C3A4E;
            }
        }
    }
    .table-employee{
        border-radius: 8px;
        padding: 0;
        margin: 30px 5px;
        font-size: 14px;
        .theading{
            width: 25%;
        }
    }
    
    .choose{
        color:#454545;
        font-family: Open Sans;
        font-style: italic;
        font-weight: normal;
        font-size: 13px;
    }
}
</style>